import { useDisplayNames } from '@spotify/confidence-core-react';

import { AggregationThresholdInput } from '../AggregationThresholdInput';
import { useAggregatedMeasurement } from './context';

export const Threshold = () => {
  const { measurement, aggregationType, threshold, entity, onThresholdChange } =
    useAggregatedMeasurement();
  const { displayNames } = useDisplayNames();

  return (
    <AggregationThresholdInput
      value={threshold}
      aggregationType={aggregationType}
      entityName={displayNames.get(entity)}
      measurementName={measurement?.name}
      onChange={newThreshold => onThresholdChange(newThreshold ?? null)}
    />
  );
};
